import {
  FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING,
  FRONTEND_STATE_SELECT_LOCATION_START,
  FRONTEND_STATE_SELECT_LOCATION_STOP,
} from './selectLocation.actionTypes';
import type { SelectLocationConfiguration } from './selectLocation.state';

export const startSelectLocationTool = (configuration: SelectLocationConfiguration) => ({
  type: FRONTEND_STATE_SELECT_LOCATION_START,
  payload: {
    configuration,
  },
}) as const;

export const stopSelectLocationTool = () => ({
  type: FRONTEND_STATE_SELECT_LOCATION_STOP,
}) as const;

export const setSelectLocationAddressIsLoading = (isLoading: boolean) => ({
  type: FRONTEND_STATE_SELECT_LOCATION_SET_ADDRESS_LOADING,
  payload: {
    isLoading,
  },
}) as const;
